
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Cases = lazy(() => import('../pages/cases/page'));
const Science = lazy(() => import('../pages/science/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/cases',
    element: <Cases />,
  },
  {
    path: '/science',
    element: <Science />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
